import {platform} from 'substance'

const keySymbolMapMac = {
    'Cmd': 'Cmd \u2318', // Cmd ⌘
    'Meta': 'Cmd \u2318', // Cmd ⌘
    'Alt': 'Alt \u2325' // Alt ⌥
}

const keySymbolMapMacShort = {
    'Cmd': '\u2318', // Cmd ⌘
    'Meta': '\u2318', // Cmd ⌘
    'Alt': '\u2325' // Alt ⌥
}

const keySymbolMapWin = {
    'Meta': '\u229e Win' // ⊞ Win
}

const keySymbolMapWinShort = {
    'Meta': '\u229e' // ⊞ Win
}

const keySymbolMapCommon = {
    'Shift': 'Shift \u21e7', // Shift ⇧
    'Return': '\u23ce', // ⏎
    'Escape': 'Esc'
}

const keySymbolMapCommonShort = {
    'Shift': '\u21e7', // Shift ⇧
    'Return': '\u23ce', // ⏎
    'Escape': 'Esc'
}

const capitalizeFirstLetter = function(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

const mapKeyToSymbol = function(key, short) {
    const keySymbolMap = Object.assign(keySymbolMapCommon, platform.isMac ? keySymbolMapMac : keySymbolMapWin)
    const keySymbolMapShort = Object.assign(keySymbolMapCommonShort, platform.isMac ? keySymbolMapMacShort : keySymbolMapWinShort)
    key = capitalizeFirstLetter(key)
    if (short) {
        return keySymbolMapShort[key] ? keySymbolMapShort[key] : key
    }
    return keySymbolMap[key] ? keySymbolMap[key] : key
}


export {mapKeyToSymbol}
